import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../../core/session.service';
import { APP_STORE_URL, PLAY_STORE_URL } from '../app-download-banner/app-download-banner.component';

export interface SetupChecklistRow {
    key: string;
    // Registered ng-icon name. Mini icons (20px) declare `iconSize: 20`.
    icon: string;
    iconSize?: 20 | 24;
    // Translation keys.
    title: string;
    description: string;
    badge?: string;
    // Navigation target: /settings;section=<section> by default.
    route?: string;
    section?: string;
    // Optional URL fragment; the target page scrolls that block into view.
    fragment?: string;
    // Right-hand illustration (e.g. app QR code) instead of the arrow.
    image?: string;
    // On mobile web the image (QR) is replaced by the App Store / Google Play badges.
    storeBadgesOnMobile?: boolean;
    imageAlt?: string;
}

// "Finish setting up Rosie" list (ENG-2292, Figma 19659-76494): stacked rows
// with a lavender icon circle, title, optional "Finish Setup" badge, a short
// description and a trailing arrow. Rows are data-driven so hosts decide
// which appear.
@Component({
    selector: 'rosie-setup-checklist',
    templateUrl: './setup-checklist.component.html',
    styleUrls: ['./setup-checklist.component.scss'],
    standalone: false
})
export class SetupChecklistComponent {
    @Input() rows: SetupChecklistRow[] = [];
    // Emitted before navigating so hosts can track the click.
    @Output() rowClicked = new EventEmitter<SetupChecklistRow>();

    readonly appStoreUrl = APP_STORE_URL;
    readonly playStoreUrl = PLAY_STORE_URL;

    constructor(private router: Router, private session: SessionService) { }

    showStoreBadges(row: SetupChecklistRow): boolean {
        return !!row.storeBadgesOnMobile && this.session.isMobileVersion;
    }

    trackByRow(index: number, row: SetupChecklistRow): string {
        return row.key;
    }

    isNavigable(row: SetupChecklistRow): boolean {
        return !!row.route || !!row.section;
    }

    onRowClick(row: SetupChecklistRow): void {
        this.rowClicked.emit(row);
        if (!this.isNavigable(row)) {
            return;
        }
        const route = row.route || '/settings';
        const extras = row.fragment ? { fragment: row.fragment } : {};
        if (row.section) {
            this.router.navigate([route, { section: row.section }], extras);
        } else {
            this.router.navigate([route], extras);
        }
    }
}
